import {
	type ClientResponse,
	handleSuccess,
	moduleName,
	type RequestParams,
	type ServerResponse,
} from "@onhandtech/onhand-fe-shared/lib/api/v5/campaign/get-campaign";
import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import {
	createRequestError,
	formatEndpoint,
	type RequestArgs,
} from "@onhandtech/onhand-fe-shared/lib/request";
import type { AxiosError } from "axios";
import { ContentPublishStatus } from "constants/publish-status";

import { getConfig } from "../../../../../config/configuration";

const args: RequestArgs<ServerResponse, ClientResponse, RequestParams, never> =
	{
		handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
		handleSuccess,
		method: "GET",
		url: formatEndpoint(getConfig().endpoints.api.v5.campaign),
	};

const getCampaignModule = () =>
	createReduxServiceModule<
		ServerResponse,
		ClientResponse,
		RequestParams,
		never,
		never,
		ContentPublishStatus
	>({
		args,
		moduleName,
		segments: [
			ContentPublishStatus.PUBLIC,
			ContentPublishStatus.TARGETED,
			ContentPublishStatus.UNPUBLISHED,
		] as const,
	});

export default getCampaignModule;
